"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var portalTabsBaseTheme = function (_a) {
    var _b;
    var DESKTOP_ONLY = _a.DESKTOP_ONLY;
    return ({
        portalTabsProps: {
            scrollButtons: "off",
            variant: "scrollable"
        },
        portalTabs: {
            "&.app-bar": {
                display: "none"
            },
            padding: "0",
            flexWrap: "nowrap",
            whiteSpace: "nowrap",
            width: "100%",
            alignContent: "center"
        },
        portalTabsItem: {
            padding: "0.625rem 0.5rem",
            flexBasis: "auto",
            flexGrow: "1",
            margin: "0",
            textAlign: "center",
            lineHeight: "1rem",
            whiteSpace: "nowrap",
            textTransform: "none",
            "&:hover": {
                textDecoration: 'none',
            }
        },
        portalTabsItemText: (_b = {
                minWidth: "auto",
                flexWrap: "nowrap",
                whiteSpace: "nowrap",
                textTransform: "none",
                fontSize: "0.875rem",
                padding: "0",
                minHeight: "auto",
                opacity: "1"
            },
            _b[DESKTOP_ONLY] = {
                fontSize: "1rem",
            },
            _b)
    });
};
exports.default = portalTabsBaseTheme;
//# sourceMappingURL=portalTabs.js.map